<template>
  <div class="intern-notes-container text-dark">
    <button class="open-button" @click="isOpen = !isOpen">
      {{ $t('vue2.subs_ongoing_absence.ongoing_absence') }}
      <div class="dot--for-autogenered hint--bottom"
           :aria-label="$t('vue2.subs_ongoing_absence.ongoing_absence')"
           v-if="absentUsersSorted.length > 0">
        {{ absentUsersSorted.length }}
      </div>
    </button>
    <transition name="slideInRight">
      <div class="subs-note" :class="{'subs-note--is-open': isOpen}" v-if="isOpen">
        <div class="subs-note__container">
          <div class="subs-note__container__header">
            <div class="subs-note__container__header__close icon__bg-circle" @click="isOpen = !isOpen">
              <span class="icon-cross2"></span>
            </div>
            <h2>{{ $t('vue2.subs_ongoing_absence.teachers_with_ongoing_absence') }}</h2>
          </div>
          <div class="subs-note__container__body">
            <h4 class="text-explainer" v-if="absentUsersSorted.length < 1">
              {{ $t('vue2.subs_ongoing_absence.no_teachers_with_ongoing_absence') }}</h4>
            <ul>
              <li class="absent-user shadow" v-for="user in absentUsersSorted">
                <div class="absent-user__badges right marg-5-left">
                  <div class=" badge badge--small badge--orange" v-if="getIsUserAbsenceAutogeneratedToday(user)">
                    {{ $t('vue2.subs_ongoing_absence.auto_created') }}
                  </div>
                </div>
                <div class="absent-user__name">
                  <img :src="user.default_thumb_url" alt=""/>
                  <p>{{ user && user.name ? user.name : '' }}</p>
                </div>
                <ul>
                  <li v-for="reason in user.reasons">
                    <h4>{{ getReasonTitle(reason) }} <span class="do-opus-badge" v-if="reason.kmd_absence_code_id">Åbenstående i OPUS</span></h4>
                    <div><span class="icon-calendar4"></span> {{ formatDate(reason.from_date) }} -
                      {{ formatDate(reason.to_date) }}
                    </div>
                    <div><span class="icon-clock"></span> {{ reason.from_time | showTime }} -
                      {{ reason.to_time | showTime }}
                    </div>
                    <div class="actions">
                      <button class="bttn bttn-primary shadow" @click="setTheEditAbsenceReason(reason)">
                        {{ $t('vue2.subs_ongoing_absence.edit_stop') }}
                      </button>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fadeIn">
      <div class="bg-overlay" v-if="isOpen" @click="isOpen = false"></div>
    </transition>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import moment from 'moment'
import DModal from '../common/DModal'

export default {
  components: {DModal},
  data () {
    return {
      isOpen: false
    }
  },
  filters: {
    showDate (date) {
      return moment(date).format('dddd, D. MMM')
    },
    showTime (date) {
      return moment(date).format('LT')
    },
    date (date) {
      return moment(date).format('ll')
    },
    absenceDate (date) {
      return moment(date).format('DD. MMM, [kl]. LT')
    }
  },
  computed: {
    ...mapGetters([
      'longAbsentListInHash',
      'usersWithOngoingAbsenceInHash',
      'allUsersInCalIdHash'
    ]),
    absentUsers () {
      if (Object.keys(this.allUsersInCalIdHash).length < 1) {
        return []
      }
      let userArr = Object.keys(this.usersWithOngoingAbsenceInHash)
      let filteredNotExisting = userArr.filter(userCalId => !this.allUsersInCalIdHash[userCalId])
      if (filteredNotExisting.length > 0) {
        console.log('filteredNotExisting', filteredNotExisting)
      }
      let filteredUser = userArr.filter(userCalId => this.allUsersInCalIdHash[userCalId])
      return filteredUser.map(userCalId => {
        let user = {
          name: this.allUsersInCalIdHash[userCalId].name,
          default_thumb_url: this.allUsersInCalIdHash[userCalId].default_thumb_url,
          reasons: this.usersWithOngoingAbsenceInHash[userCalId].absenceArr.map(absenceId => this.longAbsentListInHash[absenceId])
        }
        return user
      })
    },
    absentUsersSorted () {
      return this.absentUsers.sort((a, b) => (a.name || '').localeCompare(b.name || '', 'da'))
    },
    allEventsInAHash () {
      return this.$store.state.subs.allEventsInAHash
    },
    absenceReasons () {
      return this.$store.state.subs.absenceReasons
    },
    absenceAutogeneratedToday () {
      // Needs to be all with auto generated absence today
      let num = 0
      this.absentUsers.forEach(user => {
        if (this.getIsUserAbsenceAutogeneratedToday(user)) {
          num++
        }
      })
      return num
    },
    textAbsenceCreatedAuto () {
      return this.$t('vue2.subs_ongoing_absence.auto_created')
    },
    allAbsenceEventInEventSerialIdsHash () {
      return this.$store.state.subs.allAbsenceEventInEventSerialIdsHash
    },
    activeDate () {
      return this.$store.state.subs.date
    }
  },
  methods: {
    formatDate (date) {
      return moment(date).format('ll')
    },
    getIsUserAbsenceAutogeneratedToday (user) {
      let autoGeneratedToday = false
      user.reasons.forEach(reason => {
        let absence = this.allAbsenceEventInEventSerialIdsHash[reason.event_serial_id]
        if (!absence) {
          return autoGeneratedToday
        }
        let statusObj = absence.substitution_status ? JSON.parse(absence.substitution_status) : {}
        let todayDate = moment(this.activeDate).format('YYYY-MM-DD')
        let extendedDate = moment(statusObj['extended_at']).format('YYYY-MM-DD')
        if (statusObj['extended_at'] && moment(extendedDate).isSame(todayDate)) {
          autoGeneratedToday = true
        }
      })
      return autoGeneratedToday
    },
    getReasonTitle (reason) {
      let idx = this.absenceReasons.findIndex(absenceSubject => absenceSubject.id === reason.subject_id)
      return idx > -1 ? this.absenceReasons[idx].name : ''
    },
    getSerialListItem (reason) {
      return this.longAbsentListInHash[reason.event_serial_id] || false
    },
    getAbsenceIsRunningOut (user) {
      let end = null
      user.reasons.forEach(reason => {
        if (!end || moment(reason.to_date).isBefore(end)) {
          end = reason.to_date
        }
      })
      return end
    },
    setTheEditAbsenceReason (reason) {
      this.$store.commit('setActiveAbsenceReason', reason)
    },
    humanizeEndDate (user) {
      moment.locale(window.USER.language)
      const endDate = this.getAbsenceIsRunningOut(user)
      let diff = moment().diff(moment(endDate).endOf('day'))
      return moment.duration(diff).humanize()
    }
  }
}
</script>

<style scoped>
@import '../../assets/css/variables.css';

.subs-note {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 9980;
  width: 25%;
  font-size: 12px !important;
  min-width: 350px;
  overflow-y: auto;
  background: #edf0f5;
  box-shadow: 0 0 14px rgba(0, 0, 0, 0.2);
}

.open-button {
  display: flex;
  width: auto;
  margin-right: 1rem;
  align-items: center;
  height: 100%;
  white-space: nowrap;
}

.dot--for-autogenered {
  background-color: #e3a008;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  margin-left: 5px;
  display: flex;
  line-height: 0;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  color: #ffffff;
  font-weight: normal;
}

.subs-note__opener__icons {
  cursor: pointer;
  font-size: 20px;
  margin-left: 10px;
  margin-top: 2px;
}

.subs-note__container__header {
  position: relative;
  overflow: hidden;
  border-radius: 4px 4px 0 0;
  color: #3d4340;
  border-bottom: 1px solid #d8d8d8;
  text-align: center;
  margin-bottom: 20px;
  padding: 12px;
}

.subs-note__container__header > h2 {
  color: rgba(44, 62, 80, .8);
  text-transform: uppercase;
  font-size: 1.2rem;
}

.subs-note__container__header__close {
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
  padding: 1rem;
  cursor: pointer;
  font-size: 1.2rem;
}

.absent-user {
  margin: 0 1rem 1rem;
  border-radius: 4px;
  background: #fff;
  padding: 1rem;
}

.bg-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.25);
  z-index: 1000;
}

.absent-user__name {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.absent-user__name img {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  margin-right: 1rem;
}

.absent-user__name p {
  font-weight: bold;
  font-size: 1.2rem;
}

.actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.subs-note__container__body .text-explainer {
  margin: 0 2rem;
}

.slideInRight-enter-active {
  transition: transform .5s;
}

.slideInRight-enter, .slideInRight-leave-to {
  transform: translateX(100%);
}


.absent-user__badges {
  display: flex;
  flex-direction: column;
}

.absent-user__badges > .badge {
  margin-bottom: 5px;
}

.do-opus-badge {
  display: inline-flex;
  font-weight: 400;
  border: 1px solid #facc17;
  border-radius: 4px;
  background-color: #fefce8;
  padding: 3px 4px;
  font-size: 9px;
  line-height: 1.5;
  color: #a26206;
  vertical-align: middle;
  margin-left: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// SubsAbsentWithoutEnd.vue?285bb492